/*=========================================================================================
  File Name: moduleCalendarActions.js
  Description: Calendar Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import axios from '@/axios.js'
import con from '@/firebase/firebaseInit.ts'
import ls from "@/common/localStorage"

//const cn = 'OA_UAT_C1591205467009E1591206650065'
var cn = ls.getSessionEventCollectionName();
const trackRef = con.eventDB.collection(cn).doc('TrackList').collection('Tracks')
const storageRef = con.storageRef 

export default {
  fetchTracks ({ commit }) {
    return new Promise((resolve, reject) => {      
      const markers = []        
      trackRef.get().then(querySnapshot => {
                
        querySnapshot.docs.forEach(doc => {              
          markers.push(doc.data())           
        })  
        commit('SET_TRACKS', markers)
        resolve(markers)          
      }).catch(function (error) {
        //console.log('Error getting attendee:', error)
        reject(error)
      })
         
    })
  },
  fetchTracksDropdown ({ commit }) {
    return new Promise((resolve, reject) => {      
      const markers = []        
      trackRef.get().then(querySnapshot => {
                
        querySnapshot.docs.forEach(doc => {              
          markers.push( {TrackID: doc.data().TrackId, TrackName: doc.data().Name, ColorCode: doc.data().ColorCode ? doc.data().ColorCode : ''} )           
        })  
        commit('SET_TRACKS', markers)
        resolve(markers)          
      }).catch(function (error) {
        //console.log('Error getting attendee:', error)
        reject(error)
      })
         
    })
  },
  fetchTrack (context, id) {
    //console.log(id)
    return new Promise((resolve, reject) => {
      if (id === null) {
        resolve({
          status:200,
          data:{
            AttendeeIDs:[],
            TableName: '',
            Occupied:[],
            CreatedByName:'',
            CreatedDate:'',
            SpectatorEnable:'',
            Capacity:'6',
            ChannelName:'',
            ChannelToken:'',
            CreatedByID:'',
            IsPublished:true,
            IsTableCreator:'',
            LastModifiedDate:'',
            TableId:'',
            TableName:'',
            TopicId:'',
            TopicName:'',
            
            TableType:'Open',
            Spectate:true,
            PreAssignedType:'Public'
            
          }
        })
      } else {
        let docObj = new Object
        trackRef.doc(`${id}`).get().then(function (doc) {  
          docObj = doc.data()
          //console.log(docObj)                      
          resolve({status:200, data:docObj})              
        }).catch(function (error) {
          //console.log('Error getting mapped attendee:', error)
          reject(error)
        })
      }
      
    })
  },
  updateRoundtable (context, field) {
    return new Promise((resolve, reject) => {
      trackRef.doc(`${field.id}`).update({
        Name: `${field.data.FirstName  } ${  field.data.LastName}`,
        FirstName: field.data.FirstName,
        LastName: field.data.LastName,
        Phone: field.data.Phone,
        Country: field.data.Country,
        Company: field.data.Company,
        Designation: field.data.Designation,
        Profile: field.data.Profile,
        //ProfilePictureURL: field.data.ProfilePictureURL,         
        LastModifiedDate: new Date().getTime()
      })
        .then(function (doc) { 
          if (field.data.file) {
            const file = field.data.file
            const metadata = {
              'contentType': file.type
            }
            storageRef.child(`${cn  }/profileImage/${  new Date().getTime()  }_${  file.name}`).put(file, metadata).then(function (snapshot) {
              snapshot.ref.getDownloadURL().then(function (url) {                        
                trackRef.doc(`${field.id}`).update({ ProfilePictureURL: url.toString() }).then(function (doc) {
                  resolve({status:200, message:'Data & File Updated.'})
                }).catch(function (error) {   
                  //console.log('data update '+error)                
                })                          
              }).catch(function (error) {   
                //console.log('download url '+error)                
              })
            }).catch(function (error) {   
              //console.log('imgae upload '+error)                
            })
          } else {
            resolve({status:200, message:'Data Updated.'})
          }
                    
        }).catch(function (error) {
          //console.log('Error getting update attendee:', error)
          reject(error)
        })
    })
  },
  
  addRoundtable (context, field) {
    //console.log(atob(field.id));
    //console.log(field); 

    return new Promise((resolve, reject) => { 
    let AutoID = "RT" + new Date().getTime();
    let docObj = {
      TableId: AutoID,
      AutoID: AutoID,
      TableName: field.data.TableName,
      Capacity: field.data.Capacity,  //as seats

      Host: field.data.Host, 
      TableType:field.data.TableType,
      SpectatorEnable:field.data.Spectate,
      AttendeeIDs:field.data.AttendeeIDs, //mapp attendee
      PreAssignedType:field.data.PreAssignedType,

      Occupied:[{name: '', title: '', profileImg: '', company: ''}],
      CreatedByName:field.data.CreatedByName,
      ChannelName:field.data.ChannelName,
      ChannelToken:field.data.ChannelToken,
      CreatedByID:field.data.CreatedByID,
      IsPublished:field.data.IsPublished,
      IsTableCreator:field.data.IsTableCreator,
      CreatedDate:new Date(),
      TopicId:field.data.TopicId,
      TopicName:field.data.TopicName,
      LastModifiedDate: new Date().getTime()    
    }
    trackRef.doc(`${AutoID}`).set(docObj).then(function () { 
      resolve({status:200, message:'Data Added.', Id: field.data.TableId }) 
    }).catch(function (error) {
    reject(error)
    })    
    
    
    })



  }, 
  addTrackFromPopup (context, field) {
    //console.log(atob(field.id));
    //console.log(field); 

    return new Promise((resolve, reject) => { 
    let AutoID = "ST" + new Date().getTime();
    let docObj = {
      TrackId: AutoID,
      TitleDisplayOrder: 0,
      StartTime: '',

      StartDate: new Date(), 
      ParentID:0,
      Name:field.TrackName,
      CreatedDate: new Date(),
      LastModifiedDate: new Date(), //mapp attendee
      ID: 0,

      HasChild:false,
      EventID: '',
      EndTime: null,
      EndDate:null,
      ColorCode: field.ColorCode,
      CalendarView:[]    
    }
    trackRef.doc(`${AutoID}`).set(docObj).then(function () { 
      resolve({status:200, message:'Data Added.' }) 
    }).catch(function (error) {
      console.log(error)
      resolve({status:500, message:'Data Not Added.' }) 
    })    
    
    
    })



  }, 
  updateTrack (context, field) {
    return new Promise((resolve, reject) => { 
      let AutoID = field.TrackId
      let docObj = {
        Name: field.Name,
        ColorCode: field.ColorCode
      }
    trackRef.doc(`${AutoID}`).update(docObj).then(function () { 
      resolve({status:200, message:'Track Updated.' }) 
    }).catch(function (error) {
      resolve({status:500, message:'Track Not Updated.' }) 
    })    
    
    
    })



  }, 
  deleteTrack ({ commit }, TrackId) {
    return new Promise((resolve, reject) => {
      trackRef.doc(`${TrackId}`).delete().then(function () { 
        commit('REMOVE_RECORD', TrackId)
        resolve({status:200, message:'Track Deleted.' }) 
      }).catch(function (error) {
        console.log(error)
        resolve({status:500, message:'Track Not Deleted.' }) 
      })
    })
  },
  removeRecord ({ commit }, userId) {
    return new Promise((resolve, reject) => {
      axios.delete(`/api/user-management/users/${userId}`)
        .then((response) => {
          commit('REMOVE_RECORD', userId)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  }
}
